export default {
  create(user) {
    // Mandatory
    const values = {
      first_name: user.firstName,
      last_name: user.lastName,
      email: user.email,
      password: user.password,
      zip: user.zip,
      user_type: 'NONAGENT',
      marketing_opt: user.updateSubscribe,
      phone: user.phone,
      savedSearches: user.savedSearches,
      investorPreferences: user.investorPreferences,
    }

    // Optional
    if ('accountCreationIntent' in user) {
      values.intent = user.accountCreationIntent
    }

    if ('invitationToken' in user) {
      values.invitation_token = user.invitationToken
    }

    // Only for agents
    if (user.isAgent) {
      values.user_type = 'AGENT'

      values.agent = {
        agent_license_id: user.license,
        agent_licensed_state: user.issuingState,
        brokerage: {
          broker_license_id: user.brokerageLicense,
          brokerage_name: user.brokerageName,
          brokerage_address_street: user.addressLine,
          brokerage_address_city: user.addressCity,
          brokerage_address_state: user.addressState,
          brokerage_address_zip_code: user.addressZip,
        },
      }
    }

    return values
  },
}
